// ./app/shared/LimitToRange.directive.ts
import { 
  Directive,
  HostListener,
  ElementRef, 
  Renderer,
} from '@angular/core';

// Directive decorator
@Directive({ selector: '[limitToRange]' })
// Directive class
export class LimitToRange{
  constructor(el: ElementRef, renderer: Renderer) {}

  oldValue: any;
  min: any;
  max: any;

  @HostListener('keydown', ['$event']) onKeyDown(e){
    this.oldValue = e.target.valueAsNumber;
    this.min = Number(e.target.min);
    this.max = Number(e.target.max);
    if( e.code.slice( 0, -1 ) !== "Digit" && 
        e.code != "Backspace" ){
      e.preventDefault();
    }
  }

  @HostListener('keyup', ['$event']) onKeyUp(e){

    if( e.code.slice(0, -1)  === "Digit"){
      if( ( e.keyCode < 48 || e.keyCode > 57 )){
        e.preventDefault();
        e.target.value = this.oldValue; 
      }else if( Number( e.target.value ) > this.max ){
        e.preventDefault();
        e.target.value = this.max;
      }else if( Number( e.target.value ) < 0 ){
        e.preventDefault();
        e.target.value = 0;
      }
    }else if( e.code != "Backspace" ){
      e.preventDefault(); 
    }
  }
}



